import Grid from "@mui/material/Grid";
import { Box, Stack } from "@mui/material";
import { LabelTemplate } from "./styles/table";
import { Employee } from "../types/processTypes";

import { BasicPostAppliedSingleValue } from "./components/basic/BasicPostApplied";
import { BasicDetail } from "./components/basic/BasicDetail";
import {
  BasicLanguageDetail,
  BasicLanguageInaya,
} from "./components/basic/BasicLanguage";
import { BasicExperience } from "./components/basic/BasicExperience";
import {
  BasicSkillsTwoRows,
  BasicSkillsVer,
  BasicSkillsVerValue,
} from "./components/basic/BasicSkills";
import { BasicPassport } from "./components/basic/BasicPassport";
import {
  BasicContactNumber,
  BasicFullName,
} from "./components/basic/BasicFullName";
import { BasicFace } from "./components/basic/BasicFace";
import { BasicStand } from "./components/basic/BasicStand";
import {
  BasicRemarksBullets,
  BasicRemarksConfidential,
  BasicRemarksVer,
} from "./components/basic/BasicRemarks";
import {
  BasicReference,
  BasicReferenceEnglish,
  BasicReferenceOnlyEnglish,
} from "./components/basic/BasicReference";
import {
  BasicPassportScan,
  BasicPassportScanNoBroker,
} from "./components/basic/BasicPassportScan";
import {
  BasicHeader,
  BasicHeaderNoBorder,
} from "./components/basic/BasicHeader";
import { Company } from "../../setups/types/setupTypes";
import { BasicTitleSingleLang } from "./components/basic/BasicTitle";

interface Props {
  selectedCompany: Company;
  currentEmployee: Employee;
  backgroundColor: string;
  cvTemplate: LabelTemplate;
}
function BasicTwoTemplate({
  selectedCompany,
  currentEmployee,
  backgroundColor,
  cvTemplate,
}: Props) {
  //a08745;f2f1f0 fffcf2
  return (
    <>
      <Box id="personalData" sx={{ p: 1 }}>
        <Grid
          container
          spacing={cvTemplate.spacing}
          sx={{
            p: 1,
            backgroundColor: backgroundColor,
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              height: "90%",
              mb: 1,
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeaderNoBorder
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Grid>
          {/* <Grid item xs={12}>
            <BasicTitleSingleLang template={cvTemplate} />
          </Grid> */}
          <Grid
            container
            item
            xs={12}
            spacing={cvTemplate.spacing}
            justifyContent="center"
            alignItems="center"
          >
            {/* Short Photo */}
            <Grid item xs={3}>
              {cvTemplate && currentEmployee && (
                <BasicFace
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
              )}
            </Grid>

            <Grid container item xs={9}>
              {/* <Stack spacing={cvTemplate.spacing} sx={{ width: "100%" }}>
              </Stack> */}
              <Grid item xs={6}></Grid>
              <Grid item xs={6}>
                <BasicReferenceOnlyEnglish
                  currentEmployee={currentEmployee}
                  template={{ ...cvTemplate, showCellBorders: true }}
                />
              </Grid>
              <Grid item xs={12}>
                {cvTemplate && currentEmployee && (
                  <BasicPostAppliedSingleValue
                    currentEmployee={currentEmployee}
                    template={{ ...cvTemplate, showCellBorders: true }}
                    showName={true}
                    showHeader={false}
                    showProfession={true}
                    showSalary={true}
                    showContractPeriod={true}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <BasicContactNumber
              currentEmployee={currentEmployee}
              template={{ ...cvTemplate, showCellBorders: true }}
            />
          </Grid>
          <Grid item md={7} xs={12}>
            {cvTemplate && currentEmployee && (
              <>
                <BasicDetail
                  currentEmployee={currentEmployee}
                  template={{ ...cvTemplate, showCellBorders: true }}
                  showHeader={true}
                  showReference={false}
                  showNationality={true}
                  showPassportNumber={false}
                  showReligion={true}
                  showDateOfBirth={true}
                  showAge={true}
                  showPlaceOfBirth={true}
                  showMaritalStatus={true}
                  showNumberOfChildren={true}
                  showWeightHeight={true}
                  showComplexion={true}
                  showEducation={true}
                  showLivingTown={false}
                  showEmployeeTelephone={false}
                  showContactName={false}
                  showContactTelephone={false}
                />

                <BasicLanguageInaya
                  currentEmployee={currentEmployee}
                  template={{ ...cvTemplate, showCellBorders: true }}
                  showEducation={false}
                />

                <BasicExperience
                  currentEmployee={currentEmployee}
                  template={{ ...cvTemplate, showCellBorders: true }}
                  type="basic"
                />

                <BasicSkillsVer
                  currentEmployee={currentEmployee}
                  template={{ ...cvTemplate, showCellBorders: true }}
                />
                <BasicRemarksBullets
                  currentEmployee={currentEmployee}
                  template={{ ...cvTemplate, showCellBorders: true }}
                />
              </>
            )}
          </Grid>
          <Grid item md={5} xs={12}>
            {cvTemplate && currentEmployee && (
              <Stack
                spacing={cvTemplate.spacing}
                sx={{
                  alignItems: "center",
                }}
              >
                <BasicPassport
                  currentEmployee={currentEmployee}
                  template={{ ...cvTemplate, showCellBorders: true }}
                  showHeader={true}
                  showPassportNumber={true}
                  showIssueDate={true}
                  showPlaceOfIssue={true}
                  showExpiryDate={true}
                />

                <BasicStand
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
              </Stack>
            )}
          </Grid>
          <Grid item xs={12}>
            <BasicRemarksConfidential
              currentEmployee={currentEmployee}
              template={cvTemplate}
            />
          </Grid>
        </Grid>
      </Box>
      {cvTemplate.numberOfPages === 2 && (
        <Stack
          id="passportData"
          sx={{
            p: 1,
            pt: 1,
            backgroundColor: backgroundColor,
            minHeight: "1500px",
          }}
        >
          {cvTemplate.addPassportHeader && (
            <Box
              sx={{
                height: "90%",
              }}
            >
              {cvTemplate && currentEmployee && (
                <BasicHeaderNoBorder
                  selectedCompany={selectedCompany}
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
              )}
            </Box>
          )}
          {cvTemplate && currentEmployee && (
            <Box
              sx={{
                mt: 15,
              }}
            >
              <BasicPassportScanNoBroker
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            </Box>
          )}
        </Stack>
      )}
    </>
  );
}

export default BasicTwoTemplate;
